import React from "react";
import styled from "styled-components";
import Toggle from "./ToggleReusable";
import { AnimateSharedLayout } from "framer-motion";
const FaqSection = () => {
  return (
    <>
      <h1 style={{ textAlign: "center" }}>
        Any <span style={{ color: "#8B73FF" }}>Questions?</span>
      </h1>
      <StyledFaq>
        <AnimateSharedLayout>
          <Toggle title="How Do I connect">
            <div className="questions">
              <ul>
                <li>
                  {" "}
                  <a
                    href="https://github.com/AryanShinde"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    href="https://www.linkedin.com/in/aryan-shinde-14ab58201/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    LinkedIn
                  </a>{" "}
                </li>
              </ul>
            </div>
          </Toggle>

          <Toggle title="whats your experience">
            <div className="questions">
              <ul>
                <li>
                  {" "}
                  <a
                    href="https://github.com/AryanShinde"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    href="https://www.linkedin.com/in/aryan-shinde-14ab58201/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    LinkedIn
                  </a>{" "}
                </li>
              </ul>
            </div>
          </Toggle>

          <Toggle title="where can i find your resume">
            <div className="questions">
              <ul>
                <li>
                  {" "}
                  <a
                    href="https://github.com/AryanShinde"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    href="https://www.linkedin.com/in/aryan-shinde-14ab58201/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    LinkedIn
                  </a>{" "}
                </li>
              </ul>
            </div>
          </Toggle>

          <Toggle title="whats my github account">
            <div className="questions">
              <ul>
                <li>
                  {" "}
                  <a
                    href="https://github.com/AryanShinde"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    href="https://www.linkedin.com/in/aryan-shinde-14ab58201/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    LinkedIn
                  </a>{" "}
                </li>
              </ul>
            </div>
          </Toggle>
        </AnimateSharedLayout>
      </StyledFaq>
      <br />
      <br />
    </>
  );
};

const StyledFaq = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 4rem;
  .questions {
    width: 100%;
    height: 10vh;
    /* padding-left: 4rem; */
  }
  .answer {
    padding-bottom: 1rem;
  }
  .line-1 {
    margin-top: 0.2rem;
    width: 78rem;
    height: 0.2rem;
    background-color: black;
    margin-bottom: 2rem;
  }
`;

export default FaqSection;
